"use client";

import { Card } from "components/ui/v2";

export function EndorsementSkillCardSkeletonV2() {
  return (
    <Card size="full" padding="comfortable" shadow="subtle">
      <div className="absolute left-0 right-0 top-0 h-1 bg-slate-200 dark:bg-zinc-700" />
      <div className="animate-pulse space-y-3">
        <div className="flex items-start gap-3">
          <div className="h-11 w-11 shrink-0 rounded-xl bg-slate-200 dark:bg-zinc-700" />
          <div className="flex-1 space-y-2">
            <div className="h-5 w-3/4 rounded bg-slate-200 dark:bg-zinc-700" />
            <div className="h-4 w-1/3 rounded bg-slate-200 dark:bg-zinc-700" />
          </div>
          <div className="h-9 w-9 rounded-lg bg-slate-200 dark:bg-zinc-700" />
        </div>
        <div className="h-8 w-24 rounded-full bg-slate-200 dark:bg-zinc-700" />
      </div>
    </Card>
  );
}
